import { render } from "./UserInput.vue?vue&type=template&id=70a11f4d&scoped=true"
import script from "./UserInput.vue?vue&type=script&lang=js"
export * from "./UserInput.vue?vue&type=script&lang=js"

import "./UserInput.vue?vue&type=style&index=0&id=70a11f4d&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a11f4d"]])

export default __exports__